"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  computed: {
    key: function key() {
      return this.$route.fullPath;
    }
  }
};